import { ApiResponse } from "@/interfaces/api-response";
import { AIFilterCategory } from "@/interfaces/ai-filter.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "ai-filter-categories";

const createOne = async (data: Partial<AIFilterCategory>) => {
  const response = await apiClient.post<ApiResponse<AIFilterCategory>>(
    `/${SERVICE_ENDPOINT}`,
    data,
  );
  return response.data;
};

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  parentId?: string;
}) => {
  const response = await apiClient.get<ApiResponse<AIFilterCategory[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<AIFilterCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<AIFilterCategory>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<AIFilterCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<AIFilterCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const aiFilterCategoryApi = {
  createOne,
  getMany,
  getOneById,
  updateOneById,
  deleteOneById,
};

export default aiFilterCategoryApi;
